export default __webpack_public_path__ + "static/255-a2257446db29a4a640ef2b02936df683.gif";